import { createSlice } from "@reduxjs/toolkit";

const userAuthSlice = createSlice({
  name: "auth",
  initialState: { token: null, refreshToken: null },
  reducers: {
    loginSuccess: (state, action) => {
      const payload = action.payload;
      if (payload.token !== undefined) state.token = payload.token;
      if (payload.refreshToken !== undefined) state.refreshToken = payload.refreshToken;
      if (payload._id !== undefined) state._id = payload._id;
      if (payload.permissions !== undefined) state.permissions = payload.permissions;
      if (payload.email !== undefined) state.email = payload.email;
      if (payload.fullname !== undefined) state.fullname = payload.fullname;
      if (payload.isDocs !== undefined) state.isDocs = payload.isDocs;
      if (payload.isDocsPending !== undefined) state.isDocsPending = payload.isDocsPending;
    },
    logout: (state) => {
      state.token = "";
      state.refreshToken = "";
      state._id = "";
      state.permissions = "";
      state.email = "";
      state.fullname = "";
      state.isDocs = false;
      state.isDocsPending = false;
    },
  },
});

export const { loginSuccess, logout } = userAuthSlice.actions;
export default userAuthSlice.reducer;
